import * as types from "../../actionTypes";

const initialState = {
  data: {},
  isLoading: false,
  message: "",
  status: "",
};

const removeAvatarReducer = (state = initialState, action) => {
  console.log("prd", action);
  switch (action.type) {
    case types.REMOVE_JOBSEEKER_AVATAR_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.REMOVE_JOBSEEKER_AVATAR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case types.REMOVE_JOBSEEKER_AVATAR_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case types.RESET_JOBSEEKER_REMOVE_AVATAR:
      return {
        ...state,
        isLoading: false,
        data: {},
        status: false,
        message: "",
      };
    default:
      return state;
  }
};

export default removeAvatarReducer;
